import { defineMessages } from "react-intl";
export default defineMessages({
    locationDescription: {
        id: "intro.locationDescription",
        defaultMessage: "Enable location access to get accurate weather predictions tailored to your exact area — no more one-size-fits-all forecasts.",
    },
    locationTitle: {
        id: "intro.locationTitle",
        defaultMessage: "Forecasts Made for You",
    },
    notificationDescription: {
        id: "intro.notificationDescription",
        defaultMessage: "Turn on notifications to get timely alerts about weather changes that matter to you — rain, snow, or severe conditions, right when you need to know.",
    },
    notificationsTitle: {
        id: "intro.notificationsTitle",
        defaultMessage: "Never Miss a Weather Shift",
    },
    readyDescription: {
        id: "intro.readyDescription",
        defaultMessage: "Enjoy precise forecasts, real-time weather insights, and station data from around the globe — all in one powerful app.",
    },
    readyTitle: {
        id: "intro.readyTitle",
        defaultMessage: "You're All Set!",
    },
    welcomeDescription: {
        id: "intro.welcomeDescription",
        defaultMessage: "Get hyperlocal forecasts powered by top weather agencies — plus access to 40,000+ weather stations worldwide to see real-world conditions, past and present.",
    },
    welcomeTitle: {
        id: "intro.welcomeTitle",
        defaultMessage: "Your Weather, Reimagined",
    },
});
